import { ServiceException } from '@inter-ikea-kompis/exceptions';
import { DexfSettingsUtility } from '@inter-ikea-kompis/utilities';
import LocalizationService from '../facades/localization/LocalizationService.js';
/**
 *
 */
export default class DexfConfiguration {
    constructor(options) {
        this.settingsOptions = options;
    }
    /**
     * Returns the dexf API key that has been set.
     * If no key has been set or can't be fetched an exception will be thrown.
     */
    async getDexfApiKeyOrThrow() {
        if (this.dexfApiKey) {
            return this.dexfApiKey;
        }
        if (this.settingsOptions.dexfApiKey) {
            this.dexfApiKey = this.settingsOptions.dexfApiKey;
        }
        else {
            const localizedInformation = await this.getLocalizedInformation();
            this.dexfApiKey = localizedInformation.localization.dexfApiKey;
        }
        if (!this.dexfApiKey) {
            throw new ServiceException('DEXF API Key not set');
        }
        return this.dexfApiKey;
    }
    /**
     * Get the DEXF settings, either through the already provided DEXF settings object, or by fetching Översätta settings and transforming them to DEXF settings.
     *
     * @returns Promise of DEXF settings.
     */
    async getSettings() {
        if (this.settings) {
            return this.settings;
        }
        if (this.settingsOptions.settings) {
            this.settings = this.settingsOptions.settings;
        }
        else {
            const localizedInformation = await this.getLocalizedInformation();
            this.settings = DexfSettingsUtility.parseLocalizedInformation(localizedInformation);
        }
        return this.settings;
    }
    /**
     *
     */
    async getLocalizedInformation() {
        if (!this.localizedInformation) {
            const { locale, localizationPrefixApplication, localizationEndpoints, localizationOverrides, cache } = this.settingsOptions;
            if (!localizationEndpoints || !locale) {
                throw new ServiceException('Options to fetch localized information not set.');
            }
            const localizationService = new LocalizationService({
                localizationPrefixApplication: localizationPrefixApplication,
                localizationEndpoints: localizationEndpoints,
                localizationOverrides: localizationOverrides,
                locale: locale,
                cache: cache
            });
            this.localizedInformation = await localizationService.getLocalizedInformation();
        }
        return this.localizedInformation;
    }
}
//# sourceMappingURL=DexfConfiguration.js.map